import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type DeviceStateFragment = { __typename?: 'DeviceStateData', deviceId: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, locationId?: string | null };

export type DeviceFleetRowFragment = { __typename?: 'DeviceDocument', id: string, serial: string, name: string, profile: Types.DeviceProfile, role: Types.DeviceRole, status: Types.DeviceStatus, lastSeenAt?: Types.TDateISO | null, firmwareVersion?: string | null, connectivity?: Types.DeviceConnectivity | null, credentialStatus: Types.DeviceCredentialStatus, claimedAt?: Types.TDateISO | null, decommissionedAt?: Types.TDateISO | null, locationId?: string | null };

export type DeviceLobbyRowFragment = { __typename?: 'DeviceDocument', id: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, lastSeenAt?: Types.TDateISO | null, connectivity?: Types.DeviceConnectivity | null, claimCodeExpiresAt: Types.TDateISO, registeredAt: Types.TDateISO };

export type GetDeviceFleetQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DeviceDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.DeviceDocumentSortInput> | Types.DeviceDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetDeviceFleetQuery = { __typename?: 'Query', devices?: { __typename?: 'DevicesConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeviceDocument', id: string, serial: string, name: string, profile: Types.DeviceProfile, role: Types.DeviceRole, status: Types.DeviceStatus, lastSeenAt?: Types.TDateISO | null, firmwareVersion?: string | null, connectivity?: Types.DeviceConnectivity | null, credentialStatus: Types.DeviceCredentialStatus, claimedAt?: Types.TDateISO | null, decommissionedAt?: Types.TDateISO | null, locationId?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetDeviceLobbyQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DeviceDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.DeviceDocumentSortInput> | Types.DeviceDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetDeviceLobbyQuery = { __typename?: 'Query', deviceLobby?: { __typename?: 'DeviceLobbyConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeviceDocument', id: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, lastSeenAt?: Types.TDateISO | null, connectivity?: Types.DeviceConnectivity | null, claimCodeExpiresAt: Types.TDateISO, registeredAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetDeviceFleetTelemetryLatestQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetDeviceFleetTelemetryLatestQuery = { __typename?: 'Query', deviceTelemetryLatest: { __typename?: 'DeviceTelemetryLatestData', pairCount: number, truncated: boolean, points: Array<{ __typename?: 'DeviceTelemetryPoint', deviceId: string, metric: string, value: number }> } };

export type DeviceDetailRowFragment = { __typename?: 'DeviceDocument', id: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, lastSeenAt?: Types.TDateISO | null, firmwareVersion?: string | null, connectivity?: Types.DeviceConnectivity | null, credentialStatus: Types.DeviceCredentialStatus, registeredAt: Types.TDateISO, claimedAt?: Types.TDateISO | null, decommissionedAt?: Types.TDateISO | null, created: Types.TDateISO, updated: Types.TDateISO, locationId?: string | null, shadow?: { __typename?: 'DeviceShadowDocument', id: string, deviceId: string, desiredVersion: number, reportedVersion: number, reportedAt?: Types.TDateISO | null, updated: Types.TDateISO, desired: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }>, reported: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }>, drift: Array<{ __typename?: 'DeviceConfigDriftEntryData', key: string, desiredValue?: string | null, reportedValue?: string | null }> } | null };

export type GetDeviceDetailQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetDeviceDetailQuery = { __typename?: 'Query', device?: { __typename?: 'DeviceDocument', id: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, lastSeenAt?: Types.TDateISO | null, firmwareVersion?: string | null, connectivity?: Types.DeviceConnectivity | null, credentialStatus: Types.DeviceCredentialStatus, registeredAt: Types.TDateISO, claimedAt?: Types.TDateISO | null, decommissionedAt?: Types.TDateISO | null, created: Types.TDateISO, updated: Types.TDateISO, locationId?: string | null, shadow?: { __typename?: 'DeviceShadowDocument', id: string, deviceId: string, desiredVersion: number, reportedVersion: number, reportedAt?: Types.TDateISO | null, updated: Types.TDateISO, desired: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }>, reported: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }>, drift: Array<{ __typename?: 'DeviceConfigDriftEntryData', key: string, desiredValue?: string | null, reportedValue?: string | null }> } | null } | null };

export type GetDeviceTelemetryLatestForDeviceQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type GetDeviceTelemetryLatestForDeviceQuery = { __typename?: 'Query', deviceTelemetryLatest: { __typename?: 'DeviceTelemetryLatestData', pairCount: number, truncated: boolean, points: Array<{ __typename?: 'DeviceTelemetryPoint', deviceId: string, metric: string, value: number, unit: string, deviceTime: Types.TDateISO }> } };

export type GetDeviceTelemetryHistoryQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  metric: Types.Scalars['String']['input'];
  from: Types.Scalars['DateTime']['input'];
  to: Types.Scalars['DateTime']['input'];
  maxPoints: Types.Scalars['Int']['input'];
}>;


export type GetDeviceTelemetryHistoryQuery = { __typename?: 'Query', deviceTelemetryHistory: Array<{ __typename?: 'DeviceTelemetryBucketData', bucketStart: Types.TDateISO, averageValue: number, minValue: number, maxValue: number, lastValue: number, sampleCount: number }> };

export type GetDeviceByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetDeviceByIdQuery = { __typename?: 'Query', device?: { __typename?: 'DeviceDocument', id: string, serial: string, name: string, profile: Types.DeviceProfile, role: Types.DeviceRole, status: Types.DeviceStatus, lastSeenAt?: Types.TDateISO | null, firmwareVersion?: string | null, connectivity?: Types.DeviceConnectivity | null, credentialStatus: Types.DeviceCredentialStatus, claimedAt?: Types.TDateISO | null, decommissionedAt?: Types.TDateISO | null, locationId?: string | null } | null };

export type GetDeviceProfileConfigKeysQueryVariables = Types.Exact<{
  profile: Types.DeviceProfile;
}>;


export type GetDeviceProfileConfigKeysQuery = { __typename?: 'Query', deviceProfileConfigKeys: Array<string> };

export type GetDeviceNetworkReportQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetDeviceNetworkReportQuery = { __typename?: 'Query', device?: { __typename?: 'DeviceDocument', id: string, shadow?: { __typename?: 'DeviceShadowDocument', id: string, network?: { __typename?: 'DeviceNetworkReportData', mode: string, ipAddress?: string | null, supportsStaticNetwork: boolean } | null } | null } | null };

export type GetDeviceWifiChangeStatusQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  changeId: Types.Scalars['String']['input'];
}>;


export type GetDeviceWifiChangeStatusQuery = { __typename?: 'Query', device?: { __typename?: 'DeviceDocument', wifiChangeStatus?: { __typename?: 'DeviceWifiChangeStatusData', state: Types.DeviceWifiChangeState, reason?: string | null, at?: Types.TDateISO | null } | null } | null };

export const DeviceStateFragmentDoc = new TypedDocumentString(`
    fragment DeviceState on DeviceStateData {
  deviceId
  serial
  name
  profile
  status
  locationId
}
    `, {"fragmentName":"DeviceState"});
export const DeviceFleetRowFragmentDoc = new TypedDocumentString(`
    fragment DeviceFleetRow on DeviceDocument {
  id
  serial
  name
  profile
  role
  status
  lastSeenAt
  firmwareVersion
  connectivity
  credentialStatus
  claimedAt
  decommissionedAt
  locationId
}
    `, {"fragmentName":"DeviceFleetRow"});
export const DeviceLobbyRowFragmentDoc = new TypedDocumentString(`
    fragment DeviceLobbyRow on DeviceDocument {
  id
  serial
  name
  profile
  status
  lastSeenAt
  connectivity
  claimCodeExpiresAt
  registeredAt
}
    `, {"fragmentName":"DeviceLobbyRow"});
export const DeviceDetailRowFragmentDoc = new TypedDocumentString(`
    fragment DeviceDetailRow on DeviceDocument {
  id
  serial
  name
  profile
  status
  lastSeenAt
  firmwareVersion
  connectivity
  credentialStatus
  registeredAt
  claimedAt
  decommissionedAt
  created
  updated
  locationId
  shadow {
    id
    deviceId
    desired {
      key
      value
    }
    desiredVersion
    reported {
      key
      value
    }
    reportedVersion
    reportedAt
    updated
    drift {
      key
      desiredValue
      reportedValue
    }
  }
}
    `, {"fragmentName":"DeviceDetailRow"});
export const GetDeviceFleetDocument = new TypedDocumentString(`
    query GetDeviceFleet($where: DeviceDocumentFilterInput, $order: [DeviceDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  devices(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...DeviceFleetRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment DeviceFleetRow on DeviceDocument {
  id
  serial
  name
  profile
  role
  status
  lastSeenAt
  firmwareVersion
  connectivity
  credentialStatus
  claimedAt
  decommissionedAt
  locationId
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetDeviceLobbyDocument = new TypedDocumentString(`
    query GetDeviceLobby($where: DeviceDocumentFilterInput, $order: [DeviceDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  deviceLobby(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...DeviceLobbyRow
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment DeviceLobbyRow on DeviceDocument {
  id
  serial
  name
  profile
  status
  lastSeenAt
  connectivity
  claimCodeExpiresAt
  registeredAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetDeviceFleetTelemetryLatestDocument = new TypedDocumentString(`
    query GetDeviceFleetTelemetryLatest {
  deviceTelemetryLatest {
    points {
      deviceId
      metric
      value
    }
    pairCount
    truncated
  }
}
    `);
export const GetDeviceDetailDocument = new TypedDocumentString(`
    query GetDeviceDetail($id: String!) {
  device(id: $id) {
    ...DeviceDetailRow
  }
}
    fragment DeviceDetailRow on DeviceDocument {
  id
  serial
  name
  profile
  status
  lastSeenAt
  firmwareVersion
  connectivity
  credentialStatus
  registeredAt
  claimedAt
  decommissionedAt
  created
  updated
  locationId
  shadow {
    id
    deviceId
    desired {
      key
      value
    }
    desiredVersion
    reported {
      key
      value
    }
    reportedVersion
    reportedAt
    updated
    drift {
      key
      desiredValue
      reportedValue
    }
  }
}`);
export const GetDeviceTelemetryLatestForDeviceDocument = new TypedDocumentString(`
    query GetDeviceTelemetryLatestForDevice($deviceId: String!) {
  deviceTelemetryLatest(deviceId: $deviceId) {
    points {
      deviceId
      metric
      value
      unit
      deviceTime
    }
    pairCount
    truncated
  }
}
    `);
export const GetDeviceTelemetryHistoryDocument = new TypedDocumentString(`
    query GetDeviceTelemetryHistory($deviceId: String!, $metric: String!, $from: DateTime!, $to: DateTime!, $maxPoints: Int!) {
  deviceTelemetryHistory(
    deviceId: $deviceId
    metric: $metric
    from: $from
    to: $to
    maxPoints: $maxPoints
  ) {
    bucketStart
    averageValue
    minValue
    maxValue
    lastValue
    sampleCount
  }
}
    `);
export const GetDeviceByIdDocument = new TypedDocumentString(`
    query GetDeviceById($id: String!) {
  device(id: $id) {
    ...DeviceFleetRow
  }
}
    fragment DeviceFleetRow on DeviceDocument {
  id
  serial
  name
  profile
  role
  status
  lastSeenAt
  firmwareVersion
  connectivity
  credentialStatus
  claimedAt
  decommissionedAt
  locationId
}`);
export const GetDeviceProfileConfigKeysDocument = new TypedDocumentString(`
    query GetDeviceProfileConfigKeys($profile: DeviceProfile!) {
  deviceProfileConfigKeys(profile: $profile)
}
    `);
export const GetDeviceNetworkReportDocument = new TypedDocumentString(`
    query GetDeviceNetworkReport($id: String!) {
  device(id: $id) {
    id
    shadow {
      id
      network {
        mode
        ipAddress
        supportsStaticNetwork
      }
    }
  }
}
    `);
export const GetDeviceWifiChangeStatusDocument = new TypedDocumentString(`
    query GetDeviceWifiChangeStatus($id: String!, $changeId: String!) {
  device(id: $id) {
    wifiChangeStatus(changeId: $changeId) {
      state
      reason
      at
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetDeviceFleet: build.query<GetDeviceFleetQuery, GetDeviceFleetQueryVariables | void>({
      query: (variables) => ({ document: GetDeviceFleetDocument, variables })
    }),
    GetDeviceLobby: build.query<GetDeviceLobbyQuery, GetDeviceLobbyQueryVariables | void>({
      query: (variables) => ({ document: GetDeviceLobbyDocument, variables })
    }),
    GetDeviceFleetTelemetryLatest: build.query<GetDeviceFleetTelemetryLatestQuery, GetDeviceFleetTelemetryLatestQueryVariables | void>({
      query: (variables) => ({ document: GetDeviceFleetTelemetryLatestDocument, variables })
    }),
    GetDeviceDetail: build.query<GetDeviceDetailQuery, GetDeviceDetailQueryVariables>({
      query: (variables) => ({ document: GetDeviceDetailDocument, variables })
    }),
    GetDeviceTelemetryLatestForDevice: build.query<GetDeviceTelemetryLatestForDeviceQuery, GetDeviceTelemetryLatestForDeviceQueryVariables>({
      query: (variables) => ({ document: GetDeviceTelemetryLatestForDeviceDocument, variables })
    }),
    GetDeviceTelemetryHistory: build.query<GetDeviceTelemetryHistoryQuery, GetDeviceTelemetryHistoryQueryVariables>({
      query: (variables) => ({ document: GetDeviceTelemetryHistoryDocument, variables })
    }),
    GetDeviceById: build.query<GetDeviceByIdQuery, GetDeviceByIdQueryVariables>({
      query: (variables) => ({ document: GetDeviceByIdDocument, variables })
    }),
    GetDeviceProfileConfigKeys: build.query<GetDeviceProfileConfigKeysQuery, GetDeviceProfileConfigKeysQueryVariables>({
      query: (variables) => ({ document: GetDeviceProfileConfigKeysDocument, variables })
    }),
    GetDeviceNetworkReport: build.query<GetDeviceNetworkReportQuery, GetDeviceNetworkReportQueryVariables>({
      query: (variables) => ({ document: GetDeviceNetworkReportDocument, variables })
    }),
    GetDeviceWifiChangeStatus: build.query<GetDeviceWifiChangeStatusQuery, GetDeviceWifiChangeStatusQueryVariables>({
      query: (variables) => ({ document: GetDeviceWifiChangeStatusDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetDeviceFleetQuery, useLazyGetDeviceFleetQuery, useGetDeviceLobbyQuery, useLazyGetDeviceLobbyQuery, useGetDeviceFleetTelemetryLatestQuery, useLazyGetDeviceFleetTelemetryLatestQuery, useGetDeviceDetailQuery, useLazyGetDeviceDetailQuery, useGetDeviceTelemetryLatestForDeviceQuery, useLazyGetDeviceTelemetryLatestForDeviceQuery, useGetDeviceTelemetryHistoryQuery, useLazyGetDeviceTelemetryHistoryQuery, useGetDeviceByIdQuery, useLazyGetDeviceByIdQuery, useGetDeviceProfileConfigKeysQuery, useLazyGetDeviceProfileConfigKeysQuery, useGetDeviceNetworkReportQuery, useLazyGetDeviceNetworkReportQuery, useGetDeviceWifiChangeStatusQuery, useLazyGetDeviceWifiChangeStatusQuery } = injectedRtkApi;
